import { ProductType } from '@xing-com/crate-common-graphql-types';
import { redirectTo, useParams } from '@xing-com/crate-core-router';

/**
 * Reads the product parameter from the URL and redirects to 404 if it's not valid
 * @returns "premium" or "projobs"
 */
export function useProductParameter(): { product: ProductType } {
  const { product } = useParams();

  if (product === ProductType.Premium || product === ProductType.Projobs) {
    return { product };
  } else {
    redirectTo('/404');
    throw new Error('Invalid product type');
  }
}
